<template>
  <div>
    <Layout :pagetitle="$t('Rewards')">
      <Table
        :title="$t('Rewards')"
        :items="rewards"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="true"
        :searchable="true"
        :editable="true"
        :removable="true"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editReward"
        @onCreate="createReward"
        @onRemove="onRemove"
        @onChangePage="changePage"
      />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'slug',
          label: 'Slug'
        }
      ],
      rewards: []
    };
  },
  mounted() {
    this.getRewards();
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getRewards();
    },
    onRemove(reward) {
      this.$api.destroy(`api/reward/${reward.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('Reward was excluded with success')
        });
        this.getRewards();
      });
    },
    getRewards() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/reward', { search: this.search, page: this.page })
        .then((res) => {
          this.page = 1;
          this.$store.commit('SET_LOADING', false);
          this.rewards = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createReward() {
      this.$router.push({
        name: 'rewardCreate'
      });
    },
    editReward(reward) {
      this.$router.push({
        name: 'rewardUpdate',
        params: {
          id: reward.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.getRewards();
    }
  }
};
</script>

<style></style>
